// src/components/Shared/ForgotPasswordPage.jsx
// Request a reset link. The server answers identically whether or not the
// email has an account, so this screen never confirms who is registered —
// the confirmation copy below is deliberately conditional-free.

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import BackButton from './BackButton';

const ForgotPasswordPage = () => {
	const [email, setEmail] = useState('');
	const [sent, setSent] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		// Read from the DOM: autofill can populate the field without firing
		// onChange. Same reason as LoginPage.
		const el = e.currentTarget.elements.namedItem('email');
		const value = (typeof el?.value === 'string' ? el.value : email).trim();
		if (value !== email) setEmail(value);
		if (!value) return;

		setErrorMsg('');
		setLoading(true);
		try {
			await api.post('/auth/forgot-password', { email: value });
			setSent(true);
		} catch (error) {
			setErrorMsg(error.response?.data?.msg || 'Something went wrong. Try again.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="ev-page ev-auth-page">
			<div className="ev-auth-card">
				<div className="ev-back-row">
					<BackButton to="/login" label="Back to sign in" />
				</div>
				<div className="ev-auth-head">
					<div className="ev-auth-logo">
						<img src="/images/eventory-logo.svg" alt="Eventory" />
					</div>
					<h1 className="ev-auth-title">Reset your password</h1>
					<p className="ev-auth-subtitle">
						{sent
							? 'Check your inbox.'
							: 'Enter your email and we will send you a link to set a new one.'}
					</p>
				</div>

				{errorMsg && <div className="ev-alert ev-alert-danger">{errorMsg}</div>}

				{sent ? (
					<>
						<div className="ev-alert">
							If that email has an account, a reset link is on its way. The link works
							once and expires in 45 minutes.
						</div>
						<p className="ev-auth-switch">
							<Link to="/login" className="ev-inline-link">Back to sign in</Link>
						</p>
					</>
				) : (
					<form onSubmit={handleSubmit} className="ev-auth-grid">
						<div className="ev-auth-field">
							<label htmlFor="email">Email Address</label>
							<div className="ev-auth-input-wrap">
								<input
									type="email"
									id="email"
									name="email"
									autoComplete="email"
									className="ev-auth-input"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									placeholder="you@example.com"
									required
								/>
							</div>
						</div>

						<button type="submit" className="ev-auth-primary" disabled={loading}>
							{loading ? 'Sending…' : 'Send reset link'}
						</button>

						<p className="ev-auth-switch">
							Remembered it? <Link to="/login" className="ev-inline-link">Sign in</Link>
						</p>
					</form>
				)}
			</div>
		</div>
	);
};

export default ForgotPasswordPage;
